import React from 'react';
import { View, ScrollView,StyleSheet,Animated,TouchableOpacity,
    TouchableWithoutFeedback,Image,Button,Dimensions,Modal , ImageBackground, ActivityIndicator} from 'react-native';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import Video from 'react-native-video';
// import { WebView } from 'react-native-webview';
import { getLibraryContentInfo, 
    clearLibraryContentData, 
     getGetHtmlContent,
     dispatchClearGetHtmlContent
    } from './../../store/actions';
import { connect } from 'react-redux';
import {Card, Surface} from 'react-native-paper';
// import StylesColors from './../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import OfflineHandler from './../OfflineHandler';
// import PaymentButtonComponent from './paymentButtonComponent';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from "react-native-vector-icons/FontAwesome";
import { FOR_LIBRARY_CONTENT, REQUEST_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS } from './../../store/constants';
// import ToasterComponent from './../snackBarComponent';
// import { subscriptionPlanPaymentStatus } from './../../store/selectors';
// import { isIphoneX } from './../Utils';
import {Text, Styles} from "./../../components/UI-Components"
import Toaster from './../../components/snackBar_toaster';
import Lock from  '@material-ui/icons/Lock';
import Description from  '@material-ui/icons/Description';
import PlayArrow from  '@material-ui/icons/PlayArrow';
import ShowContentScreen from './../showContentScreen';
import Header from "./../../components/Header";
import Container from '@material-ui/core/Container';
import LoadingComponent from "./../../components/LoaderComponent";
import ShowAlertComponent from './../../components/UI-Components/showAlertBox'





// const { width, height } = Dimensions.get("window");
const width = 480;

const _width = window.innerWidth;

class ContentLibraryScreen extends React.Component{
 

    state = {
        showContent:  false,
        showAlert: false
    }
         
    
    componentDidMount() {              
     
        const { state={}} = this.props.location || {}

        const { subjectId=null, price=0, subjectName='', hasUserPaid=0,isFree=0, topicId, title} = state || {}
     
        this.setState({
            subjectName,
            price,
            hasUserPaid,
            isFree,
            subjectId,
            title,
            topicId
            // accessToLibrary       
        })   

        setTimeout(() => {
            this.setState({showMessage: true})
        }, 800)

        if(subjectId && topicId) {               
            this.props.getLibraryContentInfo(subjectId, topicId);
        }else {
            alert("please select valid exam");
        }
    }

    // componentDidUpdate(prevProps) {
    //     if(prevProps.response !== this.props.response) {
    //         if(this.props.response) {
    //             const message = this.props.response.data && this.props.response.data.message || 'Successfully payment is done';
    //             this.showToaster(message, 2000);
    //             this.props.getHomeInfo();
    //             this.props.getLibrarySubjects();
    //             setTimeout(() => {
    //                 this.props.navigation.navigate('Library');
    //             }, 2000);
    //         }
    //     }

    //     if(prevProps.paymentError !== this.props.paymentError) {
    //         if(this.props.paymentError) {
    //           setTimeout(() => { 
    //             const errorInfo = this.props.paymentErrorMessage || 'failed..'
    //             this.showToaster(errorInfo, 2000)
    //           }, 300);
    //         }
    //     }
    // }

    librarySubjectPayment = () => {
        const {subjectId, price} = this.state  
        setTimeout(() => {
            this.props.navigation.navigate('PaymentScreen', {
                paymentInfo: {                                            
                    transactionType: FOR_LIBRARY_CONTENT,
                    price,
                    subjectId
                }
            })
        }, 200);     
        // this.props.checkoutCreateTest(null, price, null, FOR_LIBRARY_CONTENT, subjectId);
    }

    componentWillUnmount() {
        this.props.clearLibraryContentData();
        this.props.dispatchClearGetHtmlContent();
    }

   
    showToaster = (msg) => {
        this.setState({
          showToast: true,
          toasterMessage: msg
        })
      }

    render(){
        const { loading, error, errorInfo, contentInfo, isContentEmpty } = this.props;
        const {  subjectName, price, hasUserPaid, isFree, accessToLibrary, showMessage } = this.state;
        // console.log(this.props.isContentEmpty);
       
        return(
            <>
                <Header
                    title="Content "
                    headerRight
                    headerRightClick={() => this.props.history.push('/Home')}
                    headerLeftClick={() => this.props.history.goBack()}
                    backButton={true}
                // headerRightClick={() => alert()}
                />
            <Container maxWidth='lg'>

            <div 
             className={`${loading ? "main-component" : 'full-height'} `}
            
            >
           
                {
                    loading && <View style={{flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                     <LoadingComponent styles={{width: 250, height: 250}}/>
                    </View>
                }

                {
                    error && <View style={{flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <Text>{ typeof errorInfo === 'string'? errorInfo : 'Something went wrong...' }</Text>
                </View>
                }
                  {
               !error && showMessage && !loading && !(contentInfo && contentInfo.length > 0 ) && <View style={{flex: 1, 
                 justifyContent:'center', alignItems:'center',}}>
                                <Text style={{fontSize: 18, fontWeight: '700'}}>Material will be updated soon...</Text>
                        </View>
                }
            
              <View style={{flex:1 }}>
              
              <View style={{ flex: 1, flexDirection: 'row', 
              flexWrap: 'wrap',

              justifyContent:_width <= 479 ? 'center' : 'flex-start',
            //   alignItems:'center',
               marginHorizontal:_width <= 780 ? 62 : 30,
                marginVertical:10,
                borderRadius:0,
                // borderWidth: 1,
                paddingHorizontal: '8%',
                alignSelf:'center',
                // borderWidth: 1
                }}>
                    {
                        contentInfo && contentInfo.length > 0 && contentInfo.map((content, index) => {
                            
                            return (
                                <>
                           
                               <TouchableWithoutFeedback
                                        onPress = {()=> {
                                            if(content?.file_type === 'video') return this.setState({
                                                showAlert: true
                                            })
                                            // if( content.is_paid  && (!isFree && !hasUserPaid) ) return this.showToaster("Paid content, purchase to continue.");
                                         
                                            this.setState({
                                                showContent: true,
                                                contentData: {
                                                   contentUrl: content.content_url,
                                                   contentType: content.file_type,
                                                   html_content:content.html_content,
                                                   title: content.title,
                                                   id: content.id,
                                                   subjectId: content.subject_id,
                                                   examId: content.exam_id,
                                                   topicId: content.topic_id,
                                                   formLibrary: true,
                                                //    videoType:content.videoType
                                                }
                                            })
                                    }
                                    }
                                    style={styles.cardComponent}
                                    >
                                   
                             <Card 
                              style={styles.mainCardComponent}
                             >
                             
                                 {/* <View
                                  style={styles.iconComponent}
                                 >
                                     {
                                        content.is_paid  && (!isFree && !hasUserPaid) ?
                                          <Lock
                                          style={{zIndex:100, width: 90, height: 90 ,color:"rgba(0,0,0,0.9)" }}
                                      />
                                          : null
                                     }

                                    
                                  
                                 </View> */}
                                 <View style={{width: '100%', height: 300}}>
                                     <Image 
                                     source={{ uri: content.image_url}} 
                                     style={{width: '100%', height: '100%'}}
                                     resizeMode='cover'
                                     />
                                 </View>
                                 {/* <Card.Cover source={{ }} resizeMode='cover' /> */}
                                <Text style={styles.imgText} ellipsizeMode='tail' numberOfLines={1} >{content.title} </Text>
                              
                             <View style={styles.fileType}>
                                     {
                                        content.file_type === 'video' ? <PlayArrow 
                                          style={{width: 12, height: 12 ,color:Styles.primaryColor }} />
                                          :<Description 
                                          style={{width: 12, height: 12 ,color:Styles.primaryColor }}
                                          />

                                       
                                     }
                                     {/* {
                                         <Text
                                         style={styles.paymentStatus}
                                     >
                                         {content.is_paid ? 'PAID' : 'FREE'}
                                        </Text>
                                     } */}
                                       
                                 </View>   
                                
                                    
                             {/* <View style={   content.is_paid  && (!isFree && !hasUserPaid)  ? styles.overLey: null}/>  */}
                             </Card>
                             
                             </TouchableWithoutFeedback>

                             
                            </>
                            )
                        })
                    }

       
                    </View>
                  
                </View>
            
                {/* {
                
                    <PaymentButtonComponent 
                    price={price}
                    subjectName={subjectName}
                    hasUserPaid={hasUserPaid}
                    onPress={this.librarySubjectPayment} 
                    style={{paddingBottom: isIphoneX() ? 25 : 0}}
                /> 
                } */}
                            
                {/* <ToasterComponent ref='toast'/> */}
                <Toaster 
                  show={this.state.showToast}
                message={this.state.toasterMessage}/>
              </div>
                </Container>
               {
                this.state.showContent ?
                 <ShowContentScreen
                 contentData={this.state.contentData}
                 open={this.state.showContent}
                 handleClose={() => this.setState({showContent: false})}
                 />
                 :
                 null
            }
            {
                this.state.showAlert ?
                <ShowAlertComponent
                  opens={this.state.showAlert}
                  handleClose={() => this.setState({
                      showAlert: false
                  })}
                />
                : null
            }
            </>
          
           
        )
    }
}

const styles = StyleSheet.create({
    mainImageView: {
        height: 250,
        width: Math.floor(width / 2 - 20),
        marginHorizontal: 10,
        // marginBottom,
        elevation: 8,
        marginTop:10,
        justifyContent:'center',
    },
    ImageView: {
        flex: 1,
        // width:Math.floor(width/2-18),
        height:400
        // borderRadius:10
    },
    container: {
        flex: 1,
        // borderWidth: 1,
    },
    closeBtn: {
        fontWeight: '800',
        position: 'absolute',
        top: 50,
        right: 15,
        zIndex: 99999,
        fontSize: 24,
        color: '#fff',
        alignItems: 'center',
    },
    imgText:{
        width: Math.floor(width / 2 - 50),
        fontSize:10,
        marginTop:5,
        paddingHorizontal:10,
        color:'#484848',
        fontWeight:"bold",
        // width:150
    },
    paymentIndicator: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: 8,
        paddingVertical:10,
        
    },
    paymentStatus: {
        fontSize: 10,
        marginLeft: 8,
        color: '#1CA511'
    },
    cardComponent:{
        width: 222,
        height: 350,        
        marginLeft: '5%', 
        marginRight: '5%',
        alignSelf: 'center'      
    },
    mainCardComponent: {
      marginHorizontal:10,
      borderRadius:0,
      marginVertical: 10,
      cursor: 'pointer',
      //added width
    //   width: '40%',
      width: 222,
        height: 350, 
      shadowColor: "#000",
      shadowOffset: {
          width: 0,
          height: 10,
      },
      shadowOpacity: 0.60,
      shadowRadius: 5.84,
      elevation: 8,
      marginVertical:5,
      alignSelf: 'center' 

    },
    iconComponent:{
        ...StyleSheet.absoluteFill,
        zIndex:1000,
        alignItems:'center',
        justifyContent:'center',
        
    },
    overLey:{
        flex:1,
        position:'absolute',
        top:0,
        left:0,
        bottom:0,
        right:0,
        backgroundColor:'rgba(255,255,255,0.4)',
        borderRadius:0
        
    },
    contentImage:{
        // zIndex:-10
        resizeMode:'contain'
    },
    fileType: {
    paddingBottom:5,
    paddingTop:5,
    // paddingHorizontal:10,
    marginRight:10,
    justifyContent:'flex-end',
    alignItems:'flex-end',
    flexDirection:'row'
        
    }
})


const mapStateToProps = state => {

return {
    loading: state.libraryContent && state.libraryContent.loading,
    error: state.libraryContent && state.libraryContent.error,
    errorInfo: state.libraryContent && state.libraryContent.errInfo && state.libraryContent.errInfo.data && state.libraryContent.errInfo.data.message,
    contentInfo: state.libraryContent && state.libraryContent.response && state.libraryContent.response.library_content,
    isContentEmpty: state.libraryContent && state.libraryContent.response && state.libraryContent.response.library_content && state.libraryContent.response.library_content.length === 0,
    // paymentError,
    // paymentErrorMessage,
    // paymentLoading,
    // response,
}
}

export default connect(mapStateToProps, { 
        getLibraryContentInfo, clearLibraryContentData, 
        getGetHtmlContent,
        dispatchClearGetHtmlContent
    })(ContentLibraryScreen);